import "../styles/legend.css";
import "../styles/coursenode.css";
import "../styles/coursemap.css";

import arr_con from "../img/arr_con.png";
import arr_rel from "../img/arr_rel.png";
import { HeatmapArea } from "../datastructures/coursedata";
import { Tooltip } from "react-tooltip";
import ecelogo_blue from "../img/ecelogo_blue.png";
import ecelogo_white from "../img/ecelogo_white.png";

export interface LegendProps {
  ZoomToArea: any;
  HeatmapOpen: HeatmapArea | undefined;
  HeatmapModalOpen: any;
  SetHeatmapFocus: any;
}

const areas = [
  { idx: 0, dscr: "Required 1st & 2nd Year Courses" },
  { idx: 1, dscr: "Photonics and Semiconductor Physics" },
  { idx: 2, dscr: "Energy Systems and Electromagnetics" },
  { idx: 3, dscr: "Analog and Digital Electronics" },
  { idx: 4, dscr: "Control, Communications & Signal Processing" },
  { idx: 5, dscr: "Computer Hardware & Computer Networks" },
  { idx: 6, dscr: "Software" },
  { idx: 7, dscr: "Science and Math Electives" },
  { idx: 8, dscr: "Other / Required Upper Year Courses" },
];

const heatmapRelevance = [
  { idx: "h-0", dscr: "Unrelated to application. area" },
  {
    idx: "h-1",
    dscr: "Indirectly beneficial/complementary for the application area.",
  },
  {
    idx: "h-2",
    dscr: "Covers core/foundational knowledge for the application area but no explicit treatment.",
  },
  { idx: "h-3", dscr: "Explicity covers application area in some depth." },
];

export default function Legend(props: LegendProps) {
  return (
    <div className="legend-container shadow-md">
      {props.HeatmapOpen && (
        <div className=" bg-white py-3 px-2 text-md border-b-2 border-gray-800 mb-4 font-bold">
          {props.HeatmapOpen.areaName}
          <i className={`fa fa-${props.HeatmapOpen?.areaIcon} mx-2`}> </i>
        </div>
      )}

      <div className="bg-gray-100 border border-black">
        <div className="font-bold border-b border-black p-1">
          LEGEND
          {/* {(props.HeatmapOpen !== undefined ? "HEATMAP LEGEND" : "AREA LEGEND")} */}
        </div>
        {/* Heatmap Switcher */}
        {props.HeatmapOpen !== undefined ? (
          <div className="">
            <div>
              {heatmapRelevance
                .slice(1)
                .reverse()
                .map((area) => {
                  return (
                    <AreaBubble
                      key={"lnmap_" + area.idx}
                      areaIdx={area.idx}
                      dscr={area.dscr}
                    ></AreaBubble>
                  );
                })}
            </div>
          </div>
        ) : (
          <div className="legend-flow">
            {areas.map((area) => {
              return (
                <div
                  className=""
                  key={`lndareabubble_${area.idx}`}
                  onClick={() => props.ZoomToArea(area.idx)}
                >
                  <AreaBubble
                    key={"lhmap_" + area.idx}
                    areaIdx={area.idx}
                    dscr={area.dscr}
                  ></AreaBubble>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {/*<div style={{ border: "1px solid black" }}></div>
     <div style={{ background: 'url("#bg-circles")' }} className='circuit-bg'>
      <span className='border border-black rounded-full w-6 h-6 text-center inline-block text-md'>&#9733;</span> <span className='text-sm'>  Area Kernel</span>
    </div>
    <br />
    <div>
      <p>A is prereq of B</p>
      <div className='my-3' style={{ borderTop: '2px dashed black' }}></div>
      <div className='my-3' style={{ borderTop: '2px dotted black' }}></div>
    </div> */}
      {/* <img className="" src={legenddescr} alt='legend description'></img> */}

      <div className="flex flex-row p-1 border-black border-l border-r align-middle justify-center bg-gray-100 transition-all">
        <div className="">★ Kernel Course</div>
      </div>
      <div className="flex-col  p-1 border-t border-l border-r border-black  bg-gray-100">
        <div className="flex flex-row align-middle justify-center">
          <div className="numberCircle">A</div>
          <img
            className="object-scale-down w-1/2 px-1"
            src={arr_con}
            alt="legend description"
          ></img>

          <div className="numberCircle">B</div>
        </div>
        {/* <p>
        A is a <em>prerequisite</em> to B <abbr title="A must be taken before B.">[?]</abbr>
      </p> */}
        <div className="flex flex-row items-center align-middle justify-center justify-items-center">
          <p>
            A is a <em>prerequisite</em> to B.
          </p>
          <i
            data-tip="A must be taken before B."
            className="mx-3 fa fa-question-circle"
          ></i>
        </div>
      </div>
      <div className="flex-col bg-gray-100  border-t border-l border-r border-black                       ">
        <div className="flex flex-row p-1 align-middle justify-center justify-items-center">
          <div className="numberCircle">A</div>
          <img
            className="object-scale-down w-1/2 px-1"
            src={arr_rel}
            alt="legend description"
          ></img>

          <div className="numberCircle">B</div>
        </div>
        <div className="flex flex-row items-center align-middle justify-center justify-items-center">
          <p>
            A is <em>related</em> to B
          </p>
          <i
            data-tip="A and B are related core Y1/Y2 courses, not strict prerequisites"
            className="mx-3 fa fa-question-circle"
          ></i>
        </div>
      </div>
      <div>
        <button
          className="bg-black w-full font-bold p-1 btn-split py-2 text-gr text-white border border-t-2 border-black"
          onClick={props.HeatmapModalOpen}
          data-tooltip-id="data-tooltip-application-areas"
          data-tooltip-content="Explore Course Application Area Heatmap"
        >
          <span>Application Areas </span>
        </button>
        <Tooltip id="data-tooltip-application-areas" place="right"></Tooltip>
      </div>
      {props.HeatmapOpen && (
        <div>
          <button
            className="bg-red-500 w-full font-bold p-1 btn-split py-2 text-gr text-white border border-t-2 border-black"
            onClick={() => props.SetHeatmapFocus(undefined)}
            data-tip="Return to Curriculum Map"
          >
            <span>Return to Curriculum Map</span>
          </button>
        </div>
      )}
    </div>
  );
}

const AreaBubble = (props) => {
  return (
    <>
      <button
        className={`area-bubble area-${props.areaIdx} cursor-pointer border-black border-b  w-full`}
        data-tooltip-content={props.dscr}
        data-tooltip-id={"tooltip-id-area-bubble-for-area-" + props.areaIdx}
      >
        <p className={"text-md " + (props.areaIdx === 8 ? "text-white" : "")}>
          {" "}
          {AreaNameSwitch(props.areaIdx)}{" "}
        </p>
      </button>
      <Tooltip
        id={"tooltip-id-area-bubble-for-area-" + props.areaIdx}
        place="right"
      >
        {" "}
      </Tooltip>
    </>
  );
};

const AreaNameSwitch = (areaIdx) => {
  switch (areaIdx) {
    case 0:
      return "Core Courses";
    // case 1:
    //   return '1. Photonics & Semicond. Physics'
    // case 2:
    //   return '2. Energy Sys. & Electromagnetics'
    // case 3:
    //   return '3. Analog & Digital Electronics'
    // case 4:
    //   return '4. Control, Comms. & Digital Signal Proc.'
    // case 5:
    //   return '5. Comp. Hardware & Comp. Networks'
    // case 6:
    //   return '6. Software'
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return "Area " + areaIdx;
    case 7:
      return "Sci/Math";
    case 8:
      return "Required";
    case "h-0":
      return "Not Covered";
    case "h-1":
      return "Complementary Coverage";
    case "h-2":
      return "Background Coverage";
    case "h-3":
      return "Explicit Coverage";
  }
};

export const ECELogo = (props) => {
  return (
    <div
      className={
        (props.mode === undefined ? "bg-gray-200" : "bg-black") +
        " ECELOGO rounded-md shadow-lg m-3"
      }
    >
      <a href="https://www.ece.utoronto.ca">
        <img
          className=""
          src={props.mode === undefined ? ecelogo_blue : ecelogo_white}
          alt="ECE Logo"
        />
      </a>
    </div>
  );
};
